<template>
  <PopUp :showPopUp="showPopUp" :lockScroll="false" :datas="contractData" @closed="popClosed">
    <!-- {{ contractData }} -->
    <slot>
      <ServiceDeal class="serviceDealSection" :datas="contractData?.contents" />
    </slot>
    <slot name="after"> </slot>
  </PopUp>
</template>
<script>
import { reactive, toRefs, computed, watch } from 'vue'
import { getContractContentCommonFn } from '@/assets/js/contract.js'
import PopUp from '@/components/common/PopUp'
import ServiceDeal from '@/components/common/serviceDeal'

export default {
  props: ['datas', 'showPopUp'],
  components: {
    PopUp,
    ServiceDeal
  },
  emits: ['popClosed'],
  setup(props, { emit }) {
    let { datas, showPopUp } = toRefs(props)
    const state = reactive({
      showPopUp,
      datas,
      contractData: {}
    })
    const popClosed = () => {
      state.contractData = {}
      emit('popClosed')
    }

    watch(
      () => state.showPopUp,
      () => {
        let contractData = {
          title: state.datas?.title || ''
        }
        contractData.option = state.datas
        contractData.contents = getContractContentCommonFn(state.datas)
        state.contractData = contractData
      }
    )

    return {
      ...toRefs(state),
      popClosed
    }
  }
}
</script>
<style lang="scss" scoped></style>
